// @flow
import {fromJS, Set} from 'immutable';
import {Store} from 'client/framework';
import settingsTableActions from './SettingsTable.actions';

export default class SettingsTableStore extends Store {
  constructor(name: string) {
    super(name);

    this.setInitialData(
      fromJS({
        visibleColumns: [],
        searchTerm: ''
      })
    );

    this.writeData('visibleColumns', Set());
    this.handleTargeted(settingsTableActions.CLEAR_SEARCH_TERM, this._clearSearchTerm);
    this.handleTargeted(settingsTableActions.SET_SEARCH_TERM, this._setSearchTerm);
    this.handleTargeted(settingsTableActions.SET_VISIBLE_COLUMNS, this._setVisibleColumns);
    this.handleTargeted(settingsTableActions.TOGGLE_COLUMN, this._toggleColumn);
  }

  _setSearchTerm(term: string) {
    this.writeData('searchTerm', term);
  }

  _clearSearchTerm() {
    this.writeData('searchTerm', '');
  }

  _setVisibleColumns(columns: Set<*>) {
    this.writeData('visibleColumns', columns);
  }

  _toggleColumn(column: string) {
    const currentColumns = this.getVisibleColumns();
    const updatedColumns = currentColumns.includes(column)
      ? currentColumns.delete(column)
      : currentColumns.add(column);

    this.writeData('visibleColumns', updatedColumns);
  }

  getSearchTerm(): string {
    return this.readData('searchTerm');
  }

  getVisibleColumns(): Set<*> {
    return this.readData('visibleColumns');
  }

  isColumnVisible(column: string): boolean {
    return this.getVisibleColumns().includes(column);
  }
}
